import { useDispatch, useSelector } from 'react-redux';
import { selectEmployees } from '../../views/employees/reducer';
import { Fragment, useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FaAngleDown } from 'react-icons/fa6';
import { setCurrentEmployee } from '../../views/tasks/actions';
import { EmployeeInitialsDropdown } from './EmployeeInitials';
import { fetchEmployees } from '../../views/employees/actions';

interface EmployeeDropdownStylizedProps {
  listHeight?: number;
  selectedEmployee: number;
  onEmployeeSelect?: any;
  disabled?: boolean;
}

export const EmployeeDropdownStylized = ({
  selectedEmployee,
  listHeight = 150,
  onEmployeeSelect,
  disabled = false,
}: EmployeeDropdownStylizedProps) => {
  const employees = useSelector(selectEmployees);
  const [employeesOpen, setEmployeesOpen] = useState(false);
  const [employeeName, setEmployeeName] = useState('--');
  const dispatch = useDispatch();

  const handleEmployeeSelect = (empId: number) => {
    dispatch(setCurrentEmployee(empId));
    if (onEmployeeSelect) onEmployeeSelect(empId);
  };

  const filterCurrent = () => {
    return employees.filter((employee: any) => employee.id !== selectedEmployee);
  };

  useEffect(() => {
    if (selectedEmployee !== null) {
      const employee = employees.find((e: any) => e.id === selectedEmployee);
      setEmployeeName(employee ? `${employee.firstName} ${employee.lastName}` : '');
    }
  }, [selectedEmployee, employees]);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, []);

  return (
    <div className={`employee-dropdown-stylized`}>
      {employees.length > 0 && (
        <div className="employee-dropdown-container">
          <Dropdown
            isOpen={employeesOpen}
            toggle={() => setEmployeesOpen(!employeesOpen)}
            onClick={(e: any) => e.stopPropagation()}
            className={`employee-name-dropdown${disabled ? ' disabled' : ''}`}
            disabled={disabled}
          >
            <DropdownToggle>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 12C13.1935 12 14.3381 11.5259 15.182 10.682C16.0259 9.83807 16.5 8.69347 16.5 7.5C16.5 6.30653 16.0259 5.16193 15.182 4.31802C14.3381 3.47411 13.1935 3 12 3C10.8065 3 9.66193 3.47411 8.81802 4.31802C7.97411 5.16193 7.5 6.30653 7.5 7.5C7.5 8.69347 7.97411 9.83807 8.81802 10.682C9.66193 11.5259 10.8065 12 12 12ZM15 7.5C15 8.29565 14.6839 9.05871 14.1213 9.62132C13.5587 10.1839 12.7956 10.5 12 10.5C11.2044 10.5 10.4413 10.1839 9.87868 9.62132C9.31607 9.05871 9 8.29565 9 7.5C9 6.70435 9.31607 5.94129 9.87868 5.37868C10.4413 4.81607 11.2044 4.5 12 4.5C12.7956 4.5 13.5587 4.81607 14.1213 5.37868C14.6839 5.94129 15 6.70435 15 7.5ZM21 19.5C21 21 19.5 21 19.5 21H4.5C4.5 21 3 21 3 19.5C3 18 4.5 13.5 12 13.5C19.5 13.5 21 18 21 19.5ZM19.5 19.494C19.4985 19.125 19.269 18.015 18.252 16.998C17.274 16.02 15.4335 15 12 15C8.565 15 6.726 16.02 5.748 16.998C4.731 18.015 4.503 19.125 4.5 19.494H19.5Z"
                  fill="#212326"
                />
              </svg>
              &nbsp;{employeeName}&nbsp;
              <FaAngleDown fill="#A0A0A3" />
            </DropdownToggle>
            <DropdownMenu
              className="dropdown-menu-right"
              right
              style={{ maxHeight: listHeight ? `${listHeight}px` : '300px', overflowY: 'auto' }}
            >
              {filterCurrent().map((employee: any, i: number) => (
                <Fragment key={employee.id}>
                  {i !== 0 && <DropdownItem divider />}
                  <DropdownItem
                    onClick={() => handleEmployeeSelect(employee.id)}
                  >{`${employee.firstName} ${employee.lastName}`}</DropdownItem>
                </Fragment>
              ))}
            </DropdownMenu>
          </Dropdown>
          <EmployeeInitialsDropdown
            selectedEmployee={selectedEmployee}
            onEmployeeSelect={handleEmployeeSelect}
          />
        </div>
      )}
    </div>
  );
};
